<template>
  <CustomModal @close="$emit('close')">
    <template v-slot:header>
      <div class="bank-manage-modal__head">
        <div class="mr-4 w-14-2 h-14-2 rounded-full">
          <img :src="connection.bank.logo_url"
               :alt="`${connection.bank.name}_logo`">
        </div>
        <div class="text-text-secondary text-xl font-bold leading-relaxed">
          {{ connection.bank.name }}
        </div>
      </div>
    </template>
    <template v-slot:body>
      <div class="bank-manage-modal">
        <div class="text-text text-xl font-bold leading-relaxed mb-11">{{ $t('pickAnAccount') }}</div>
        <ManageBankAccount v-for="(account,i) in connection.accounts"
                           :key="`account-${i}`"
                           :ref="`account-${i}`"
                           :used-accounts-ids="usedAccountsIds"
                           :accounts-in-connection-ids="accountsInConnectionIds"
                           :account="account"
                           @selectAccount="addUsedAccount"
                           @removeUsedAccount="removeFromUsedAccount"/>
        <div class="mt-28 flex items-center">
<!--          <BaseButton @click="save"-->
<!--                      class="w-78 lg:w-91 mr-8"-->
<!--                      theme="gray"-->
<!--                      :loading="submitted">-->
<!--            {{ $t('saveChanges') }}-->
<!--          </BaseButton>-->
<!--          <BaseButton @click="$emit('close')"-->
<!--                      :loading="submitted"-->
<!--                      class="w-50 lg:w-68 mr-20"-->
<!--                      theme="white">-->
<!--            {{ $t('cancel') }}-->
<!--          </BaseButton>-->
          <ArchiveBtn @confirm="disconnect"
                      :submitted="submitted"
                      class="ml-auto">
            <template #icon>
              <IconCrossCircle class="text-red"/>
            </template>
            <template #text>
              {{ disconnectLabel }}
            </template>
          </ArchiveBtn>
        </div>
      </div>
    </template>
  </CustomModal>
</template>

<script>
import CustomModal from "@/components/UI/modals/CustomModal";
import BaseToggle from "@/components/UI/BaseToggle";
import BaseRadioGroup from "@/components/UI/BaseRadioGroup";
import BaseRadio from "@/components/UI/BaseRadio";
import AccountsSelect from "@/components/UI/BaseSelect/AccountsSelect";
import {mapActions, mapState} from "vuex";
import BaseButton from "@/components/UI/BaseButton";
import ManageBankAccount from "@/components/cabinet/SpaceSettings/BanksIntegrations/ManageBankAccount";
import IconCrossCircle from "@/components/icons/IconCrossCircle";
import ArchiveBtn from "@/components/UI/ArchiveBtn";

export default {
  name: "ConnectionEditModal",
  components: {
    ArchiveBtn,
    IconCrossCircle,
    ManageBankAccount, BaseButton, AccountsSelect, BaseRadio, BaseRadioGroup, BaseToggle, CustomModal
  },
  props: {
    connection: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      submitted: false,
      usedAccountsIds: []
    }
  },
  computed: {
    ...mapState('space', ['current_space']),
    disconnectLabel() {
      if (this.connection.bank.country_code === 'XO') {
        return this.$t('disconnectPaymentSystem');
      }
      return this.$t('disconnectBank');
    },
    accountsInConnectionIds() {
      return [...this.connection.accounts].map(account => !!account.account_mk ? account.account_mk.id : null)
    },
  },
  methods: {
    ...mapActions('space/banks', ['connectAccounts', 'disconnectProvider']),
    setUsedAccountsIds() {
      this.connection.accounts.forEach(account => {
        if (account.enabled) this.usedAccountsIds.push(account.connected_to.id)
      })
    },
    addUsedAccount([oldId, accountId]) {
      if (oldId) this.removeFromUsedAccount(oldId);
      this.usedAccountsIds.push(accountId)
    },
    removeFromUsedAccount(accountId) {
      let accountIdIndex = this.usedAccountsIds.indexOf(accountId)
      this.usedAccountsIds.splice(accountIdIndex, 1)
    },
    prepareData() {
      let data = {
        space_id: this.current_space.data.id,
        connect: [],
        disconnect: [],
      }
      for (let accManager in this.$refs) {
        let accData = this.$refs[accManager][0].getAccountData();
        accData.enabled ?
            data.connect.push({
              remote_id: accData.uid,
              local_id: accData.connect ? accData.connected_account.id : null
            })
            : data.disconnect.push(accData.uid)
      }
      return data;
    },
    async save() {
      this.submitted = true;
      let data = this.prepareData();
      try {
        const res = await this.connectAccounts(data);
        if (res.body.success) {
          this.$emit('closeOnSave');
        }
      } catch (error) {
        this.$toasted.error('Ошибка')
        console.log(error)
      } finally {
        this.submitted = false;
      }
    },
    async disconnect() {
      if (this.submitted) return;
      this.submitted = true;
      try {
        const data = {
          space_id: this.current_space.data.id,
          connection_id: this.connection.id
        }
        const res = await this.disconnectProvider(data);
        if (res.body.success) {
          this.$emit('closeOnSave');
        }
      } catch (error) {
        this.$toasted.error('Ошибка')
        console.log(error)
      } finally {
        this.submitted = false;
      }
    }
  },
  mounted() {
    this.setUsedAccountsIds();
  },
  i18n: {
    messages: {
      en: {
        pickAnAccount: 'Pick an account form integration',
        account: 'Account',
        saveChanges: 'Save changes',
        cancel: 'Cancel',
        disconnectBank: 'Disconnect bank',
        disconnectPaymentSystem: 'Disconnect payment system',
      },
      ru: {
        pickAnAccount: 'Выберите счет для интеграции',
        account: 'Счёт',
        saveChanges: 'Сохранить изменения',
        cancel: 'Отмена',
        disconnectBank: 'Отключить банк',
        disconnectPaymentSystem: 'Отключить платежную систему',
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bank-manage-modal {
  @apply -mx-8 -mb-12  mt-0 py-10 px-16 bg-white-top-gradient rounded;
  width: 600px;
  @media(min-width: 1230px) {
    @apply -mx-12;
    width: 820px;
  }

  &__head {
    @apply flex items-center -m-8 mb-0 bg-line rounded-t;
    padding: 2.7rem 4rem;
    @media(min-width: 1230px) {
      @apply -m-12 mb-0;
    }
  }

  &::v-deep .radio {
    margin-bottom: 0;

    .radio__label {
      @apply text-2sm;
    }
  }
}
</style>